/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithGrid_shoppingWith = {
    readonly title: string | null;
    readonly quote: {
        readonly __typename: string;
    } | null;
    readonly items: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ShoppingWithTile_item">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithQuote_shoppingWith">;
    readonly " $refType": "ShoppingWithGrid_shoppingWith";
};
export type ShoppingWithGrid_shoppingWith$data = ShoppingWithGrid_shoppingWith;
export type ShoppingWithGrid_shoppingWith$key = {
    readonly " $data"?: ShoppingWithGrid_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithGrid_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithGrid_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quote",
      "storageKey": null,
      "args": null,
      "concreteType": "ShoppingWithQuote",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ShoppingWithTile_item",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithQuote_shoppingWith",
      "args": null
    }
  ]
};
(node as any).hash = '1d992e6c96ee09492009c59583327b34';
export default node;
